import { getPaymentAccounts } from 'entities/paymentAccount/api/getPaymentAccounts'
import { createPaymentAccount } from 'entities/paymentAccount/api/createPaymentAccount'
import { deletePaymentAccounts } from 'entities/paymentAccount/api/deletePaymentAccounts'

export const PaymentAccountApi = {
    getPaymentAccounts,
    createPaymentAccount,
    deletePaymentAccounts,
}
